import React from "react";
import { Tag } from "antd";

export const PLANTILLAS_SMS = [
  {
    id: 1,
    nombre: "Confirmación de proveedor asignado",
    color: "green",
    mensaje: `Estimado/a cliente,

Le informamos que su servicio ya fue asignado al proveedor correspondiente.
La unidad se dirige a su ubicación.

Tiempo estimado de llegada: [XX minutos].

Le mantendremos informado sobre cualquier actualización.`,
  },
  {
    id: 2,
    nombre: "Seguimiento - Proveedor en camino",
    color: "geekblue",
    mensaje: `Estimado/a cliente,

Le confirmamos que el proveedor ya se encuentra en camino hacia su ubicación para brindarle el servicio solicitado.

Tiempo aproximado de arribo: [XX minutos].

Quedamos atentos ante cualquier comentario.`,
  },
  {
    id: 3,
    nombre: "Notificación de llegada",
    color: "cyan",
    mensaje: `Estimado/a cliente,

El proveedor se encuentra próximo a su ubicación, pedimos estar pendiente de su llegada.`,
  },
  {
    id: 4,
    nombre: "Aviso de retraso en el servicio",
    color: "volcano",
    mensaje: `Estimado/a cliente,

Le informamos que el proveedor presenta un ligero retraso debido a [tráfico / alta demanda / condiciones de la zona].

El nuevo tiempo estimado de llegada es de [XX minutos].

Agradecemos su comprensión y seguimos monitoreando su servicio.`,
  },
  {
    id: 5,
    nombre: "Confirmación de llegada del proveedor",
    color: "green",
    mensaje: `Estimado/a cliente,

Le informamos que el proveedor ya se encuentra en el lugar para brindarle el servicio solicitado.`,
  },
];

export default function PlantillasSMS({ onSelect }) {
  return (
    <div style={{ marginTop: 20 }}>
      <div className="inputLabel" style={{ marginBottom: 8 }}>Plantillas rápidas:</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {PLANTILLAS_SMS.map((plantilla) => (
          <Tag
            key={plantilla.id}
            color={plantilla.color}
            style={{
              cursor: "pointer",
              padding: "4px 12px",
              fontSize: 13,
              transition: "all 0.15s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = "scale(0.95)";
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onClick={() => onSelect(plantilla)}
          >
            {plantilla.nombre}
          </Tag>
        ))}
      </div>
    </div>
  );
}
